module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('loader', {
    attrs: {
      "message": "Loading email templates"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.templates && !_vm.templates.length) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, _vm._l((_vm.templates), function(template) {
    return _c('template-card', {
      key: template.id,
      attrs: {
        "id": parseInt(template.id, 10),
        "name": template.name,
        "subject": template.subject,
        "type": template.type,
        "content": template.content
      },
      on: {
        "onEdit": function($event) {
          return _vm.handleOnEdit($event, template)
        }
      }
    })
  }), 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row profile-dashboard-wrapper border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [_c('h2', [_vm._v("Automated Email Templates")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "empty"
  }, [_vm._v("No email templates found.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e698818","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/automatedemails/templates/TemplateList.vue
// module id = 3238
// module chunks = 3